export const demoQuestions = {

"premium-current-affairs":[
{
q:"What is India's latest AI mission initiative?",
a:"India AI Mission aims to develop national AI infrastructure and innovation ecosystem."
},
{
q:"Which country hosted G20 Summit recently?",
a:"India hosted the G20 Summit focusing on global economic cooperation."
},
{
q:"What is Digital Public Infrastructure?",
a:"A system enabling digital identity, payments and governance platforms."
},
{
q:"What is QUAD alliance?",
a:"Strategic partnership between India, USA, Japan and Australia."
},
{
q:"What is Green Hydrogen Mission?",
a:"India's initiative for clean energy transition."
}
],

"premium-question-bank":[
{
q:"Fundamental Rights are included in which part?",
a:"Part III of Indian Constitution."
},
{
q:"Who appoints Election Commissioner?",
a:"President of India."
},
{
q:"Article 21 deals with?",
a:"Right to Life and Personal Liberty."
},
{
q:"Finance Commission formed under?",
a:"Article 280."
},
{
q:"Rajya Sabha maximum strength?",
a:"250 members."
}
],

"premium-notes":[
{
q:"What is Federalism?",
a:"Division of powers between central and state government."
},
{
q:"Meaning of Secularism?",
a:"State treats all religions equally."
},
{
q:"Judicial Review?",
a:"Power of courts to examine laws."
},
{
q:"Rule of Law?",
a:"Law is supreme over individuals."
},
{
q:"Directive Principles?",
a:"Guidelines for governance."
}
],

"premium-mock":[
{
q:"GDP full form?",
a:"Gross Domestic Product."
},
{
q:"Inflation meaning?",
a:"Increase in price level."
},
{
q:"Fiscal Deficit?",
a:"Difference between revenue and expenditure."
},
{
q:"Repo Rate controlled by?",
a:"Reserve Bank of India."
},
{
q:"NITI Aayog role?",
a:"Policy think tank."
}
]

};